export enum AuthState {
  loggedIn = 1,
  loggedOut = 2,
  loggingIn = 3,
  loginFailed = 4,
}
